module.exports = __webpack_public_path__ + "assets_1775109859079/img/logo_v1.3a0c9ddb.png";